import request from '../request';

// 试卷详情
export const paperInfo = (query) => {
  return request({
    url: '/api/zgsource_manage/platformPaper/paperInfo',
    method: 'post',
    data: query,
  });
};

// 新建/编辑 试卷（使用模板，把id置为null）
export const paperEdit = (query) => {
  return request({
    url: '/api/zgsource_manage/platformPaper/edit',
    method: 'post',
    data: query,
  });
};

// 试卷 发布/下线
export const paperRelease = (query) => {
  return request({
    url: '/api/zgsource_manage/platformPaper/release',
    method: 'post',
    data: query,
  });
};

// 试卷 删除
export const paperDelete = (query) => {
  return request({
    url: '/api/zgsource_manage/platformPaper/delete',
    method: 'post',
    data: query,
  });
};

// 试卷列表
export const paperList = (query) => {
  return request({
    url: '/api/zgsource_manage/platformPaper/platformPaperList',
    method: 'post',
    data: query,
  });
};
// 选择试卷列表
export const getChoosePaperList = (query) => {
  return request({
    url: '/api/zgsource_manage/schoolPaper/getChoosePaperList',
    method: 'post',
    data: query,
  });
};

// 保存为模版
export const saveAsTemplate = (query) => {
  return request({
    url: '/api/zgsource_manage/platformPaper/saveAsTemplate',
    method: 'post',
    data: query,
  });
};
